<template>
  <div class="relative" :class="[open && openWrapperClass, !open && closedWrapperClass]">
    <button
      type="button"
      :aria-expanded="open ? 'true' : 'false'"
      aria-haspopup="true"
      class="w-full flex justify-between items-center focus:outline-none"
      :class="[buttonClass, open && openButtonClass]"
      @click="toggle"
    >
      <span class="flex-1 min-w-0">
        <slot name="button">
          {{ label }}
        </slot>
      </span>
      <slot name="icon">
        <component
          :is="chevronIcon"
          size="1.5x"
          class="ml-4 flex-shrink-0"
          aria-hidden="true"
        />
      </slot>
    </button>

    <div v-show="open" :class="contentClass">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChevronUpIcon, ChevronDownIcon } from '~/components/veke-ui/icons'

defineProps({
  label: {
    type: String,
    required: false,
    default: ''
  },
  closedWrapperClass: {
    type: [Object, Array, String],
    required: false,
    default: ''
  },
  openWrapperClass: {
    type: [Object, Array, String],
    required: false,
    default: ''
  },
  buttonClass: {
    type: [Object, Array, String],
    required: false,
    default: ''
  },
  openButtonClass: {
    type: [Object, Array, String],
    required: false,
    default: ''
  },
  contentClass: {
    type: [Object, Array, String],
    required: false,
    default: ''
  },
  transition: {
    type: String,
    required: false,
    default: ''
  }
})

const emit = defineEmits(['dropdown-toggle'])

const open = ref(false)

const chevronIcon = computed(() => {
  return open.value ? ChevronUpIcon : ChevronDownIcon
})

const toggle = () => {
  open.value = !open.value
  emit('dropdown-toggle', open.value)
}
</script>
